/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ShipmentImperfectionReason {
  ManualQuoting = "manual_quoting",
  ManualBooking = "manual_booking",
  OpsChangedPickupDate = "ops_changed_pickup_date",
  OpsChangedShipmentDetails = "ops_changed_shipment_details",
  OpsCancelledShipment = "ops_cancelled_shipment",
  PutOnHold = "put_on_hold",
  ManualTrackingLine = "manual_tracking_line",
  OpsMarkedShipmentStatus = "ops_marked_shipment_status",
  OpsChangedExpectedDeliveryDate = "ops_changed_expected_delivery_date",
  OpsSetProNumber = "ops_set_pro_number",
  OpsSetCarrierPickupNumber = "ops_set_carrier_pickup_number",
  OpsConfirmedBooking = "ops_confirmed_booking",
  MissedPickup = "missed_pickup",
  MissedDelivery = "missed_delivery",
  FreightLost = "freight_lost",
  FreightMissing = "freight_missing",
  FreightShort = "freight_short",
  FreightDamaged = "freight_damaged",
  OpsHandledCustoms = "ops_handled_customs",
  PaymentNeedsAction = "payment_needs_action",
  ManualInvoiceUpload = "manual_invoice_upload",
  InvoiceAudit = "invoice_audit",
  ManualDocumentUpload = "manual_document_upload",
}

export function instanceOfShipmentImperfectionReason(value: any): boolean {
  for (const key in ShipmentImperfectionReason) {
    if (Object.prototype.hasOwnProperty.call(ShipmentImperfectionReason, key)) {
      if (
        ShipmentImperfectionReason[
          key as keyof typeof ShipmentImperfectionReason
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentImperfectionReasonFromJSON(
  json: any,
): ShipmentImperfectionReason {
  return ShipmentImperfectionReasonFromJSONTyped(json, false);
}

export function ShipmentImperfectionReasonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentImperfectionReason {
  return json as ShipmentImperfectionReason;
}

export function ShipmentImperfectionReasonToJSON(
  value?: ShipmentImperfectionReason | null,
): any {
  return value as any;
}

export function ShipmentImperfectionReasonToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentImperfectionReason {
  return value as ShipmentImperfectionReason;
}
